/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import * as z from "zod";
import type { ToZod } from "../.kubb/ToZod.ts";
import type { EServiceTime } from "../types/EServiceTime.ts";

/**
 * @description 1 = UpTo1Year | 2 = OneToThreeYears | 3 = ThreeToFiveYears | 4 = MoreThanFiveYears | 5 = NotApplicable |
 */
export const eServiceTimeSchema = z
  .union([z.literal(1), z.literal(2), z.literal(3), z.literal(4), z.literal(5)])
  .describe(
    "1 = UpTo1Year | 2 = OneToThreeYears | 3 = ThreeToFiveYears | 4 = MoreThanFiveYears | 5 = NotApplicable | ",
  ) as unknown as ToZod<EServiceTime>;
